var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utxo",attrs:{"income":_vm.isIncome}},[_c('p',{staticClass:"action"},[_vm._v(_vm._s(_vm.actionText))]),_c('p',{staticClass:"amount",style:({
            color: _vm.color,
        })},[_vm._v(" "+_vm._s(_vm.amountText)+" "+_vm._s(_vm.symbolText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }